export default __webpack_public_path__ + "static/media/codebase.1d578a23.svg";